// extracted by mini-css-extract-plugin
module.exports = {"formItem":"ReportProductConsumption_formItem__1H6wo"};